"use strict";

import Web3 from 'web3'

export default class Metamask {

  constructor() {
    if (window.ethereum) {
      this.provider = 'ethereum'
        this.web3 = new Web3(ethereum);
    }
    else if (window.web3) {
        this.provider = null
        this.web3 = new Web3(web3.currentProvider);
    }
  }

  isInstalled(){
    if (typeof this.web3 !== 'undefined'){
      return true
    } 
    return false
  }

  getAccount() {
    return this.web3.eth.getAccounts()
        .then((account)=>{
       return account[0]
    })
  }

  getBalance(account) {
    return this.web3.eth.getBalance(account).then((balance)=>{
      return balance
    })
  }

  getGasPrice(account) {
    return this.web3.eth.getGasPrice().then((gas)=>{
      return gas
    })
  }

  getProvider() {
    return this.provider
  }

  getTransactionCount(account) {
    return this.web3.eth.getTransactionCount(account).then((count)=>{
      return count
    })
  }

  getContract(data) {
    return new this.web3.eth.Contract(data.abi, data.contractAddress, {
        from: data.from, 
        gasPrice: data.gasPrice,
        gas: data.gasLimit
    })
  }
 
  sendTransaction(obj) {
    return this.web3.eth.sendTransaction(obj).then((receipt)=>{
      return receipt
    })
  }


  sendRawTranaction(data, contract) {
  

    // var privKey = new Buffer('fc3...', 'hex');
    // var tx = new Tx(rawTransaction);

    // tx.sign(privKey);
    // var serializedTx = tx.serialize();

    // return web3.eth.sendRawTransaction('0x' + serializedTx.toString('hex'), function(err, hash) {
    //     return hash
    // });
  }
}